import styled, { css } from 'styled-components';
import { spacing, colors } from 'ui/theme';
import { CheckboxGroupProps, Direction, Type, Option } from './types';

const CheckboxContainerTypeStyling = {
  [Type.Default]: ``,
  [Type.Bordered]: css<{
    $error: Option['hasError'];
    $status: Option['status'];
    $disabled: Option['isDisabled'];
  }>`
    padding: ${spacing.threeQuarter} ${spacing.base};
    border: ${spacing.eighth} solid ${colors.grey15};
    border-color: ${({ $error, $status, $disabled }) => {
      switch (true) {
        case $error: {
          return colors.red100;
        }
        case $disabled: {
          return colors.grey15;
        }
        case $status === true:
          return colors.green50;
        default:
          return colors.grey15;
      }
    }};
    border-radius: ${spacing.threeEights};
    background-color: ${({ $disabled }) => ($disabled ? colors.grey1 : 'inherit')};
    &:hover {
      border-color: ${({ $disabled }) => ($disabled ? colors.grey15 : colors.grey50)};
    }
    &:focus-within {
      border-color: ${colors.purple50};
      [role='checkbox']:focus {
        box-shadow: none;
        outline: none;
      }
    }
  `,
};

export const CheckboxContainer = styled.div<{
  $disabled: Option['isDisabled'];
  $error: Option['hasError'];
  $status: Option['status'];
  $type: CheckboxGroupProps['type'];
}>`
  align-items: center;
  display: flex;
  gap: ${spacing.half};
  ${({ $type }) => $type && CheckboxContainerTypeStyling[$type]}
`;

export const CheckboxGroupContainer = styled.fieldset<{
  $direction: CheckboxGroupProps['direction'];
}>`
  all: unset;
  display: grid;
  gap: ${spacing.base};
  grid-template-columns: ${({ $direction }) =>
    $direction === Direction.Vertical ? '1fr' : 'repeat(2, 1fr)'};
`;
